import { removeEmptyOptions as removeEmpties, uniqueBy } from "utils";
import flatten from "lodash/flatten";
import flattenDeep from "lodash/flattenDeep";

export const getOrientations = (d) => {
  const arr = [];
  d.forEach((item) => {
    arr.push(
      item?.map((oriItem) => ({ name: oriItem?.title, value: oriItem?.title }))
    );
  });
  const result = removeEmpties(
    uniqueBy(arr.flat() || [], (item) => item?.value)
  );
  return result;
};

export const getSegments = (d) => {
  const arr = [];
  d.forEach((item) => {
    arr.push(
      item?.map?.((oriItem) => ({
        name: oriItem?.segmentAndSegmentType,
        value: oriItem?.segmentAndSegmentType,
      })) || []
    );
  });
  const result = removeEmpties(
    uniqueBy(arr.flat() || [], (item) => item?.value)
  );
  return result;
};

export const getUitTypes = (d) => {
  const arr = [];
  d.forEach((item) => {
    arr.push(
      item?.map?.(
        (oriItem) =>
          oriItem?.coursesList?.map?.((course) => ({
            name: course?.unitType,
            value: course?.unitType,
          })) || []
      )
    );
  });

  const result = removeEmpties(
    uniqueBy(arr.flat().flat() || [], (item) => item?.value)
  );

  return result;
};
// removeEmpties(
//   uniqueBy(
//     flatten(
//       d?.map?.(
//         (oriItem) =>
//           oriItem?.coursesList?.map?.((course) => ({
//             name: course?.unitType,
//             value: course?.unitType,
//           })) || []
//       )
//     ),
//     (v) => v?.value
//   )
// );
export const getCategories = (d) => {
  const arr = [];
  d?.forEach((item) => {
    arr.push(
      flatten(
        item?.map?.(
          (oriItem) =>
            oriItem?.coursesList?.map((course) => ({
              name: course?.category,
              value: course?.category,
            })) || []
        )
      ),
      (v) => v?.value
    );
  });
  return removeEmpties(uniqueBy(arr.flat(), (v) => v?.value));
};
// export const getCategories = (d) =>
//   removeEmpties(
//     uniqueBy(
//       flatten(
//         d?.map?.(
//           (oriItem) =>
//             oriItem?.coursesList?.map((course) => ({
//               name: course?.category,
//               value: course?.category,
//             })) || []
//         )
//       ),
//       (v) => v?.value
//     )
//   );

export const getTerms = (d) => {
  const arr = [];
  d.forEach((item) => {
    arr.push(
      flatten(
        item?.map?.((oriItem) =>
          !oriItem?.planningList
            ? []
            : oriItem?.planningList?.map((termPlanning) => ({
                name: termPlanning?.title,
                value: termPlanning?.title,
              })) || []
        )
      )
    );
  });
  return removeEmpties(uniqueBy(arr.flat(), (v) => v?.value));
};

export const getProfessors = (d) => {
  const arr = [];
  d.forEach((item) => {
    arr.push(
      flattenDeep(
        item?.map?.((oriItem) =>
          !oriItem?.planningList
            ? []
            : oriItem?.planningList?.map?.(
                (term) =>
                  term?.courses?.map?.((course) => ({
                    name: course?.professor,
                    value: course?.professor,
                  })) || []
              )
        )
      )
    );
  });
  return removeEmpties(uniqueBy(arr.flat(), (v) => v.value));
};

export const flatPlanningList = (planningLists = []) => {
  // Init
  if (
    !planningLists ||
    !Array.isArray(planningLists) ||
    planningLists.length === 0
  )
    return planningLists;
  const result = [];

  // Format all in one
  planningLists.forEach((item, i) => {
    item.forEach((plng, ki) => {
      if (plng.planningList) {
        plng.planningList.forEach((termPlng, kj) => {
          termPlng.courses.forEach((termCourses, kl) => {
            result.push({
              ...termCourses,
              meta: {
                uniqueKey: `${plng.segmentAndSegmentType}||${plng.title}||${plng.type}`,
                position: {
                  index: i,
                  courseIndex: ki,
                  planningIndex: kj,
                  termIndex: kl,
                },
              },
            });
          });
        });
      }
    });
  });

  return result;
};

// For Thesis
const reformOptions = (list = [], mapFunc = (v) => v) =>
  removeEmpties(uniqueBy(list?.map?.(mapFunc), (v) => v.value));

export const getAdvisor = (thesis) =>
  reformOptions(thesis, (thes) => ({
    name: thes.advisor,
    value: thes.advisor,
  }));

export const getStudents = (thesis) =>
  reformOptions(thesis, (thes) =>
    thes.studentName?.length > 0 || thes.studentFamily?.length > 0
      ? {
          name: `${thes.studentName} ${thes.studentFamily}`.trim(),
          value: `${thes.studentName} ${thes.studentFamily}`.trim(),
        }
      : undefined
  );

export const getEducationalSegment = (thesis) =>
  reformOptions(thesis, (thes) => ({
    name: thes.educationalSegment,
    value: thes.educationalSegment,
  }));

export const getEducationalMajors = (thesis) =>
  reformOptions(thesis, (thes) => ({
    name: thes.educationalMajor,
    value: thes.educationalMajor,
  }));

export const getThesisTypes = (thesis) =>
  reformOptions(thesis, (thes) => ({
    name: thes.thesisType,
    value: thes.thesisType,
  }));

export const getThesis = {
  advisors: getAdvisor,
  students: getStudents,
  segments: getEducationalSegment,
  majors: getEducationalMajors,
  types: getThesisTypes,
};

export default {
  getCategories,
  getOrientations,
  getSegments,
  getUitTypes,
  getThesis,
  getTerms,
  getProfessors,
  flatPlanningList,
};
